import type { Me } from '@mollusk/shared';

const PUBLIC = new Set(['/login', '/auth/verify']);
/** Internal QA tools: admins only (#171). */
const ADMIN_PREFIXES = [
  '/admin',
  '/permit-detail',
  '/planning-detail',
  '/contractor-detail',
  '/parcel-map',
];

/**
 * Where the app should send the visitor, or null to stay put (#170).
 * `me`: undefined = still loading, null = signed out.
 */
export function routeFor(me: Me | null | undefined, pathname: string): string | null {
  if (me === undefined) return null;
  if (me === null) return PUBLIC.has(pathname) ? null : '/login';
  if (pathname === '/login') return '/';
  if (me.needs_terms) return pathname === '/terms' ? null : '/terms';
  if (me.role !== 'admin' && ADMIN_PREFIXES.some((p) => pathname.startsWith(p))) return '/';
  return null;
}
